export const userFriendlySecond = (miliseconds: number): number => {
    return miliseconds / 1000; //convert to seconds
};
